import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const Hourglass: FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_10172_12849)"><path d="M17 21H7V16L12 12L7 8V3H17V8L12 12L17 16V21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M5 3H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M5 21H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 20.0011L10.75 17.0011C11.48 16.4111 12.52 16.4111 13.25 17.0011L17 20.0011V21.0011H7V20.0011Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<defs><clipPath id="clip0_10172_12849"><rect width="24" height="24" fill="white" /></clipPath></defs></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Hourglass;